module.exports = __webpack_public_path__ + "static/media/iphone_8_dark.545c29cf.svg";